import * as React from 'react';
import { classNames, ScriptLoader } from 'uitk-react-utils';
import styles from './uitk-video.css';
import { useVideoHook } from './uitk-video-custom-hook.esm.js';
import { getVideoId } from './uitk-video-helper.esm.js';
import { UitkVideoLayer } from './uitk-video-layer.esm.js';

// Exclude this file from Jest due to testing issues on hooks. Will have to circle back on this.
var getClassNameList = classNames.bind(styles);
var UitkVideo = function (_a) {
  var alt = _a.alt,
    analytics = _a.analytics,
    className = _a.className,
    isDialog = _a.isDialog,
    src = _a.src,
    buttonText = _a.buttonText;
  var _b = useVideoHook(analytics),
    playerError = _b.playerError,
    onPlayerError = _b.onPlayerError,
    isPlayerReady = _b.isPlayerReady,
    onPlayerReady = _b.onPlayerReady,
    playerState = _b.playerState,
    onPlayerStateChange = _b.onPlayerStateChange,
    player = _b.player,
    setPlayer = _b.setPlayer,
    onClickPlay = _b.onClickPlay,
    onClickPause = _b.onClickPause;
  var videoId = getVideoId(src);
  var _c = React.useState(videoId),
    playerVideoId = _c[0],
    setPlayerVideoId = _c[1];
  var uniqueIdRef = React.useRef(playerVideoId + Math.random().toString(36)); // Can replace with useId in React 18
  var wrapperVideoClassNames = getClassNameList('uitk-video', className);
  /* istanbul ignore next */
  var createPlayer = function () {
    setPlayer(new window.YT.Player("player-".concat(videoId).concat(isDialog ? '-dialog' : ''), {
      events: {
        onError: onPlayerError,
        onReady: onPlayerReady,
        onStateChange: onPlayerStateChange
      },
      height: '100%',
      playerVars: {
        controls: 1,
        disablekb: 1,
        enablejsapi: 1,
        iv_load_policy: 3,
        modestbranding: 1,
        rel: 0
      },
      videoId: videoId,
      width: '100%'
    }));
  };
  React.useEffect(function () {
    if (!window.RunOnYouTubeIframeAPIReady) {
      window.RunOnYouTubeIframeAPIReady = new Map();
    }
    if (!window.onYouTubeIframeAPIReady) {
      window.onYouTubeIframeAPIReady = function () {
        // Dequeue and run all functions in the map
        while (window.RunOnYouTubeIframeAPIReady.size) {
          window.RunOnYouTubeIframeAPIReady.forEach(function (fn, key) {
            fn();
            window.RunOnYouTubeIframeAPIReady.delete(key);
          });
        }
      };
    }
    // YT could be available but YT.Player isn't available yet, especially on a Slow network.
    // YT.Player is added by a different script (www-widgetapi.js) than window.YT
    if (!window.YT) {
      ScriptLoader.getScript("https://www.youtube.com/iframe_api").catch(console.error);
      window.RunOnYouTubeIframeAPIReady.set(uniqueIdRef.current, createPlayer);
    } else if (!window.YT.Player) {
      window.RunOnYouTubeIframeAPIReady.set(uniqueIdRef.current, createPlayer);
    } else if (!player && !window.RunOnYouTubeIframeAPIReady.has(uniqueIdRef.current)) {
      createPlayer();
    } else if (player && videoId !== playerVideoId && isPlayerReady) {
      setPlayerVideoId(videoId);
      player.cueVideoById(videoId);
    }
  });
  if (typeof document === 'undefined') {
    return null;
  }
  return React.createElement("div", {
    className: wrapperVideoClassNames
  }, React.createElement(UitkVideoLayer, {
    alt: alt || '',
    controls: {
      pause: onClickPause,
      play: onClickPlay
    },
    buttonText: buttonText,
    isPlayerReady: isPlayerReady,
    playerError: playerError,
    playerState: playerState,
    src: src
  }), React.createElement("div", {
    id: "player-".concat(videoId).concat(isDialog ? '-dialog' : '')
  }));
};
export { UitkVideo };